<template>
  <div>
    <CRow>
      <CCol md="12">
        <p style="text-align: center;"><img src="main_logo.png" style="width: 140px; margin: 0 auto;" alt="Logo Oscuro"></p>
        <h1 style="text-align: center;">Bienvenido</h1>
        <p style="text-align: center;" v-if="customer.name">{{customer.name.toUpperCase()}}</p>                
        <div style="text-align: right;">
          <CButton v-if="is_impersonating" @click="backToAdmin" color="info" size="sm" style="margin-right: 8px;">Regresar al Admin</CButton>
          <CButton @click="logout" color="dark" size="sm" v-c-tooltip="{content: 'Ver Contrato', placement: 'top'}">Cerrar Sesión</CButton>
        </div>
        <hr />
        <CCard v-for="enrollment in enrollments" :key="enrollment.enrollment_id">
          <CCardHeader>
            <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap;">
              <div>
                <b>{{enrollment.travel_name}}</b><br />
                <b><a :href="enrollment.travel_form.presentation_link" target="_blank">Presentación del Viaje</a></b><br /><br />
                {{enrollment.student_name.toUpperCase()}}<br />
              </div>
              <div style="display: flex; gap: 8px; flex-wrap: wrap; justify-content: flex-end;">
                <CButton v-if="enrollment.contract_filename != ''" color="info" size="sm" @click="downloadContract(enrollment.contract_filename)" v-c-tooltip="{content: 'Ver Contrato', placement: 'top'}">Contrato</CButton>
                <CButton v-if="enrollment.responsive_filename != ''" color="info" size="sm" @click="downloadResponsive(enrollment.responsive_filename)" v-c-tooltip="{content: 'Ver Responsiva', placement: 'top'}">Responsiva</CButton>
                <CButton v-if="enrollment.passport_filename" color="success" size="sm" @click="downloadPassport(singleFile(enrollment.passport_filename))" v-c-tooltip="{content: 'Ver Pasaporte', placement: 'top'}">Pasaporte</CButton>
                <CButton v-if="enrollment.visa_filename" color="success" size="sm" @click="downloadVisa(singleFile(enrollment.visa_filename))" v-c-tooltip="{content: 'Ver Visa', placement: 'top'}">Visa</CButton>
              </div>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="12">
                <p v-if="getEnrollmentPayments(enrollment).length > 0">
                  <span style="font-weight: bold;">PAGOS</span><br />
                </p>
                <p v-if="getEnrollmentPayments(enrollment).length == 0">NO SE HAN DEFINIDO LOS PAGOS</p>
                <hr />
                <table v-for="payment in getEnrollmentPayments(enrollment)" :key="payment.id" style="width: 100%">
                  <tr>
                    <td>
                      {{payment.name}}
                    </td>
                    <td></td>
                    <td style="text-align: right; width: 95px; border: 0px solid;" v-if="payment.amount > 100 && payment.amount != 99999 && payment.amount != 88888">{{payment.currency != 'MXN' ? payment.currency : ''}} ${{payment.amount | icurrency}} {{payment.currency != 'MXN' ? '' : 'Pesos'}}</td>
                    <td style="text-align: right; width: 95px; border: 0px solid;" v-if="payment.amount > 0 && payment.amount <= 100">{{parseInt(payment.amount)}}%</td>
                    <td style="text-align: right; width: 95px; border: 0px solid;" v-if="payment.amount == 99999">PENDIENTE</td>
                    <td style="text-align: right; width: 95px; border: 0px solid;" v-if="payment.amount == 88888">RESTO</td>
                  </tr>
                  <tr v-if="payment.bank_account && payment.status != 'ACEPTADO'">
                    <td colspan="3" style="text-align: right">
                      <br />
                      <div style="padding-left: 10px; font-size: 12px;"><strong>Realiza este pago a la siguiente cuenta:</strong><br />
                        <br />
                        <div style="padding-left: 20px;">
                          Beneficiario : {{payment.bank_account.name}}<br />
                          Banco : {{payment.bank_account.bank_name}}<br />
                          Número de cuenta: {{payment.bank_account.account_number}}<br />
                          Cuenta Clabe: {{payment.bank_account.account_clabe}}
                        </div>
                      </div>
                    </td>
                  </tr>                 
                  <tr>
                    <td colspan="3" style="text-align: right">
                      <br v-if="payment.bank_account " />
                        <CButton v-if="payment.status != 'VALIDADO'" color="dark" size="sm" @click="uploadModal(enrollment.enrollment_id, payment)">{{payment.status == 'PENDIENTE' ? 'Registrar Pago' : 'Editar Pago'}}</CButton>
                        <CButton v-if="payment.status == 'VALIDADO'" color="success" size="sm">{{payment.base_amount != payment.amount ? "PAGADO: " : "PAGADO: "}} {{payment.base_amount != payment.amount ? payment.base_amount : payment.amount | currency}} Pesos</CButton>
                      <br />
                      <span v-if="payment.status != 'VALIDADO'" :style="'font-size: 12px; color: '+payment.color">{{payment.status}}</span>
                      <hr />
                    </td>
                  </tr>
                </table>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <UploadPaymentModal ref="uploadModal" @store="storeProcess"></UploadPaymentModal>
    <FileMultipleUpload ref="uploadMultipleModal" @upload="upload"></FileMultipleUpload>
  </div>
</template>
<script>

import store from '../../store'
import ws from '../../services/enrollments';
import users_ws from '../../services/users';
import UploadPaymentModal from '../../components/enrollments/UploadPaymentModal.vue';
import FileMultipleUpload from '../../components/travels/students/FileMultipleUpload.vue'
import router from '../../router/index';
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    UploadPaymentModal,
    FileMultipleUpload
  },
  props: {
    
  },
  data () {
    return {
      customer: false,
      enrollments: [],
      paymentsByEnrollment: {},
      activeEnrollmentId: 0,
      is_impersonating: false,
    }
  },
  mounted: async function() {
    this.is_impersonating = !!localStorage.getItem("impersonation_context");

    let response = await ws.getCustomer();

    if(response.type == "success"){
      this.customer = response.data;
    }

    let response2 = await ws.getEnrollments();

    if(response2.type == "success"){
      this.enrollments = response2.data;
      this.loadPayments();
    }
  },
  methods: {
    async loadPayments(){
      const requests = this.enrollments.map(async (enrollment) => {
        const response = await ws.getEnrollmentPayments(enrollment.enrollment_id);
        this.$set(this.paymentsByEnrollment, enrollment.enrollment_id, response.type == "success" ? response.data : []);
      });

      await Promise.all(requests);
    },
    async refreshEnrollmentPayments(enrollmentId){
      const response = await ws.getEnrollmentPayments(enrollmentId);
      this.$set(this.paymentsByEnrollment, enrollmentId, response.type == "success" ? response.data : []);
    },
    getEnrollmentPayments(enrollment){
      return this.paymentsByEnrollment[enrollment.enrollment_id] || [];
    },
    singleFile(value) {
      return String(value || '').split(',')[0].trim();
    },
    uploadMultipleModal (student_id, enrollment, field , code) {
      return;
      
      let item = {
        travel_id: enrollment.travel_id,
        travel_form_id: enrollment.travel_form_id,
        code: code
      };

      this.$refs.uploadMultipleModal.show("Cargar Archivos", student_id, item, field);
    },
    upload: function(){
      window.location.reload();
    },
    logout: function(){
      localStorage.removeItem("account");
      localStorage.removeItem("token");
      localStorage.removeItem("impersonation_context");

      router.push("login");
    },
    async backToAdmin(){
      const contextRaw = localStorage.getItem("impersonation_context");
      if(!contextRaw){
        this.showToast("error", "No se encontró una sesión de administrador para restaurar.");
        return;
      }

      try {
        const context = JSON.parse(contextRaw);
        if(!context.admin_token){
          this.showToast("error", "La sesión de administrador no es válida.");
          return;
        }

        const response = await users_ws.restoreImpersonation({ admin_token: context.admin_token });
        if(response.type != "success"){
          this.showToast(response.type || "error", response.message || "No fue posible restaurar la sesión de administrador.");
          return;
        }

        localStorage.setItem("token", context.admin_token);
        axios.defaults.headers.common['access-token'] = context.admin_token;
        localStorage.removeItem("impersonation_context");
        this.is_impersonating = false;

        const returnRoute = context.return_route ? context.return_route : '/travels';
        router.push(returnRoute);
      }
      catch(e){
        this.showToast("error", "Ocurrió un error al restaurar la sesión de administrador.");
      }
    },
    async downloadVisa (url) {
      window.open(url, '_blank');
    },
    async downloadPassport (url) {
      window.open(url, '_blank');
    },
    async downloadContract (url) {
      window.open(url, '_blank');
    },
    async downloadResponsive (url) {
      window.open(url, '_blank');
    },
    uploadModal (enrollmentId, payment) {
      this.activeEnrollmentId = enrollmentId;
      this.$refs.uploadModal.storeModal(payment);
    },
    async storeProcess(data){
      if(!this.activeEnrollmentId){
        return;
      }

      this.loading();
      let response = await ws.uploadPayment(data, this.activeEnrollmentId);
      
      if(response.type == "success"){
        await this.refreshEnrollmentPayments(this.activeEnrollmentId);
      }
      this.loaded();
      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
